import { makeStyles } from '@mui/styles';
import { COLORS } from '../../../EatClubTheme';

const useStyles = makeStyles((theme) => ({
  mobileHeader: {
    alignItems: 'center',
    background: COLORS.LINEN,
    display: 'flex',
    padding: '20px',
    position: 'sticky',
    zIndex: 99,
    top: 0,
    height: '66px',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  menuLogo: {
    left: '0',
    margin: '0 auto',
    position: 'absolute',
    right: '0',
    width: '150px',
    color: '#E54439',
  },
}));

export default useStyles;
